import React from "react";
import {
    Form,
    Modal,
    Typography,
    Button,
    notification,
    DatePicker,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import CleaningTraceabilityApi from "../../Apis/CleaningTraceabilityApi";
import moment from 'moment';

const { Title } = Typography;
function ViewNodeModel({ visible, onClose, NodeModeDatas }) {
    const [formAdd2] = Form.useForm();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const getCurrentFormat = (timestamp) => {
        const date = new Date(timestamp);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
        return formattedDate;
    };
    const [Traceability, setTraceability] = React.useState([]);

    function handleDateChange(date, dateString) {
        CleaningTraceabilityApi.ListcleaningTraceabilityAssign().then((response) => {

            console.log(response);
            setTraceability(response.payloadDto.filter(item => item?.traceabilityType === NodeModeDatas && (getCurrentFormat(item?.cleaningTraceabilityAddDate) === getCurrentFormat(date))))

            const asd = response.payloadDto.filter(item => item?.traceabilityType === NodeModeDatas );

            CleaningTraceabilityApi.SingleCleaningTraceability2(asd[0]?.cleaningTraceabilityItemDTO?.id, NodeModeDatas).then((response2) => {

                const date2 = response2?.payload?.cleaningTraceabilityInformationList.filter(item => item?.id === asd[0]?.cleaningTraceabilityItemDTO?.id);
                console.log(date2[0]?.managerNote)
                console.log(response2?.payload)

                formAdd2.setFieldsValue({
                    managerNote: date2[0]?.managerNote,
                });

            })
                .catch((err) => {
                    console.log(err);
                });

        })
            .catch((err) => {
                console.log(err);
            });
    }


    const handleSubmit = (data) => {
        let formData = JSON.stringify({
            cleaningTraceabilityType: NodeModeDatas,
            managerNote: data.managerNote,
            cleaningTraceabilityDTOList: Traceability.map((number) => ({ id: number?.cleaningTraceabilityItemDTO?.id })),
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        });
        CleaningTraceabilityApi.PutCleaningTraceabilitycommon(formData)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Updated</span>,
                    description: "Updated Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 500);

            })
            .catch((err) => {
                console.log(err);
                // Error Notification
                if (err.apiError.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });


    }

    const handleCancel = () => {
        formAdd2.resetFields();
        onClose();
    };
    function disabledDate(current) {
        return current && current >= moment().endOf('day');
    }

    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    View Manager Note
                </Title>
                <Form
                    form={formAdd2}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        {/* <ManagerNodeModel onCleaningfResponse={handleStorageResponse} NodeModeData={NodeModeDatas} /> */}

                        <Form.Item
                            name="OCROUBD"
                            label="Select Date"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Date ",
                                },
                            ]}
                        >
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                disabledDate={disabledDate}
                                onChange={handleDateChange}
                                placeholder="Select Date"
                                className="form-control control-input"
                            />
                        </Form.Item>
                        < Form.Item
                            name="managerNote"
                            label="Manager Note "
                            className="text-lable pt-3"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Manager Note ",
                                },
                            ]}
                        >
                            <TextArea
                                className="form-control control-input p-3"
                                rows={3}
                                style={{ resize: "none" }}
                            ></TextArea>
                        </Form.Item>


                    </>
                </Form>
            </Modal>
        </>
    );
}

export default ViewNodeModel;
